import { useStore } from '../Store'
import VisitService from '../services/VisitService'

const useVisits = () => {
    const { updateUnsaved, deleteUnsaved, removeState } = useStore()

    const updateVisit = async (visit, finish=false, isOnline=true) => {
        if (isOnline) {
            visit.observations = visit.observations.filter(obs => obs.dirty)

            visit.statusId = (finish ? 4 : 3)
            await VisitService.updateVisit(visit)
            // remove visit from unsaved list
            deleteUnsaved(visit)

        } else {
            // add visit to unsaved list
            updateUnsaved(visit)
        }
        // verwijder edit state in localstorage
        removeState()
    }

    const activateVisit = async (visit) => {
        const response = await VisitService.updateStatus(visit, 3)
        return response.data
    }

    return { updateVisit, activateVisit }
}

export default useVisits
